export default __webpack_public_path__ + "static/media/img_blanketBaseBunny_beige.10f260d7.jpg";